import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { bootstrapTheme } from './lib/theme/useTheme';
import '@fontsource-variable/bricolage-grotesque';
import './index.css';

// Paint the stored scheme before React's first frame, so the app never flashes
// the :root defaults on the way to the user's theme.
bootstrapTheme();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
